'use client'

import Link from 'next/link'
import { useState } from 'react'

import Icon from '../../components/Icon'
import ReviewStars from '../../components/ReviewStars'
import { useWindowSize } from '../../hooks/useWindowSize'
import { FormattedReview, ReviewsWidgetProps } from '../../types'
import ReviewModal from './ReviewModal'
import ReviewsCarousel from './ReviewsCarousel'

function ReviewsWidget({
  id,
  reviews,
  reviewsUrl,
  title,
  reviewsText,
  fromText,
  verifiedCustomerText,
}: ReviewsWidgetProps) {
  const [showModal, setShowModal] = useState<FormattedReview | null>(null)
  const { windowSize } = useWindowSize()

  const handleReviewClick = (review: FormattedReview) => {
    setShowModal(review)
    document.body.style.overflow = 'hidden'
  }

  const handleModalClose = () => {
    setShowModal(null)
    document.body.style.overflow = 'auto'
  }

  return reviews?.ratings.reviewsScore != null ? (
    <div className='mx-5 xl:mx-10' id={id}>
      <div className='mb-12 flex flex-col justify-between gap-8 xl:flex-row xl:items-center xl:gap-0'>
        <h3>{title}</h3>

        <Link
          href={reviewsUrl}
          className='flex flex-wrap gap-x-4 gap-y-1 no-underline'
          target='_blank'
        >
          <div className='flex items-center gap-2'>
            <ReviewStars score={reviews?.ratings.reviewsScore ?? 0} starSize={16} />

            <p>{reviews?.ratings?.reviewsScore ?? 0} / 5.0</p>
          </div>

          <p className='flex items-center gap-2 border-b border-darkgray text-darkgray'>
            {`${reviews?.ratings?.reviewsCount ?? 0} ${reviewsText}`}
            <Icon name='MdLaunch' size={windowSize.width < 1024 ? 16 : 20} />
          </p>
        </Link>
      </div>

      <div>
        <ReviewsCarousel
          reviews={reviews?.reviews}
          fromText={fromText}
          onReviewClick={handleReviewClick}
          verifiedCustomerText={verifiedCustomerText}
        />
      </div>

      {showModal !== null && (
        <ReviewModal
          onClose={handleModalClose}
          showReview={showModal}
          fromText={fromText}
          verifiedCustomerText={verifiedCustomerText}
        />
      )}
    </div>
  ) : null
}

export default ReviewsWidget
